import {
    Component,
    forwardRef,
    Input,
    Inject,
    Output,
    EventEmitter,
} from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AlertController } from "@ionic/angular";
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { UpdateConditionsDialogDialogComponent } from "./dialog/updateconditionsdialog.dialog.component";
import { RouteCMRController } from "@shared/src/controllers/route/cmr/routecmr.controller";

export const SharedUpdateConditionsDialogComponent_NOSEPERQUESERVEIXA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UpdateConditionsDialogDialogComponent),
    multi: true,
};

@Component({
    selector: "updateconditions-dialog",
    templateUrl: "./shared.updateconditionsdialog.component.html",
    styleUrls: ["./shared.updateconditionsdialog.component.scss"],
    providers: [SharedUpdateConditionsDialogComponent_NOSEPERQUESERVEIXA],
})
export class SharedUpdateConditionsDialogComponent {
    @Output() public onConfirm: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() public onCancel: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Input() title: string = "";
    @Input() paramstitle: any;

    @Input() routePartCMRId: number;
    @Input() conditions: string;
    
    private _expanded: boolean = false;
    @Input() public set expanded(value: boolean) {
        if (value)
            this.clickHelpNoIonic();

        this._expanded = value;
    }

    public get expanded(): boolean {
        return this._expanded;
    }

    public useIonic: boolean = false;

    public position = "below";

    constructor(
        private translate: TranslateService,
        private mdDialog: MatDialog,
        private alertController: AlertController,
        private ecmrController: RouteCMRController,
        @Inject("HomeController") protected homecontroller: HomeController
    ) {
        if (homecontroller.useIonic) this.useIonic = homecontroller.useIonic();
    }

    ngOnInit() { }

    clickHelpNoIonic() {
        let dialog = this.mdDialog.open(UpdateConditionsDialogDialogComponent, {
            disableClose: true,
            width: "600px",
            //height: '300px',
            data: { 
                title: this.gettitle(), 
                conditions: this.conditions,  
                routePartCMRId: this.routePartCMRId 
            },
        });

        dialog.backdropClick().subscribe((data) => {
            this.onCancel.next(true);
        });

        dialog.componentInstance.onResolve.subscribe((data: boolean) => {
            if (data) this.onConfirm.next(true);
            else this.onCancel.next(true);
        });

        this.mdDialog.afterAllClosed.subscribe(() => { });
    }

    gettitle() {
        if (this.title != null && this.title != "")
            return this.translate.instant(
                this.title,
                this.paramstitle
            );

        return "";
    }
}
